import {PEDIDOSLC_OBTENER_PEDIDOS_REQUEST, PEDIDOSLC_REALIZAR_PEDIDO_REQUEST} from '../constants/pedidoslc.constants';

export const obtenerPedidosLc = payload => ({
  type: PEDIDOSLC_OBTENER_PEDIDOS_REQUEST,
  payload,
});
export const realizarPedidoLc = payload => ({
  type: PEDIDOSLC_REALIZAR_PEDIDO_REQUEST,
  payload,
});
